import { isRelatorioConciliacaoSped } from "./relatorioConciliacaoSped.util";

/** Códigos de catálogo aceitos para processamento de apuração. */
export const CODIGOS_RELATORIO_APURACAO_VALIDOS = [
  "CONCILIACAO_SPED",
  "V3_GRUPO_INSERIR_LOTE",
  "ESOCIAL",
  "ICMS_APURACAO",
  "ICMS_ST_CAT42",
  "NOTAS_FISCAIS_APURACAO",
  "ECD_APURACAO",
  "ECF_APURACAO",
  "ICMS_ST_APURACAO",
];

/**
 * Relatório utilizável na apuração (Conciliação SPED, V3, eSocial ou ICMS).
 * @param {string | null | undefined} nome
 * @param {string | null | undefined} codigoRelatorio
 * @returns {boolean}
 */
export function isRelatorioApuracaoProcessavel(nome, codigoRelatorio) {
  const codigoUpper = (codigoRelatorio ?? "").trim().toUpperCase();
  if (CODIGOS_RELATORIO_APURACAO_VALIDOS.includes(codigoUpper)) {
    return true;
  }
  if (isRelatorioConciliacaoSped(nome, codigoRelatorio)) {
    return true;
  }
  if (codigoUpper.startsWith("V3_") || codigoUpper === "V3") {
    return true;
  }
  const nomeUpper = (nome ?? "").toUpperCase();
  if (nomeUpper.includes("V3") && nomeUpper.includes("GRUPO")) {
    return true;
  }
  return false;
}

/**
 * TXM-336 — identifica o relatório eSocial, para separar dos campos que só
 * fazem sentido para SPED/V3 (termos de exclusão, critério de contas ECD).
 * Achado ao implementar: `isRelatorioApuracaoProcessavel` inclui "ESOCIAL" em
 * `CODIGOS_RELATORIO_APURACAO_VALIDOS` de propósito (para liberar a criação da
 * apuração), mas `ModalNovaApuracao` reusava esse mesmo booleano só para
 * decidir se mostrava campos que são conceitos exclusivos de SPED — isso
 * vazava para eSocial (mostrava "Termos de exclusão"/"Apenas contas de
 * resultado", que não existem nesse motor).
 * @param {string | null | undefined} codigoRelatorio
 * @returns {boolean}
 */
export function isRelatorioEsocial(codigoRelatorio) {
  return (codigoRelatorio ?? "").trim().toUpperCase() === "ESOCIAL";
}

/** Códigos que apuram por competência mensal do SPED Fiscal/ECD (TXM-418). */
const CODIGOS_RELATORIO_ICMS = [
  "ICMS_APURACAO",
  "ICMS_ST_CAT42",
  "NOTAS_FISCAIS_APURACAO",
  "ECD_APURACAO",
  "ECF_APURACAO",
  "ICMS_ST_APURACAO",
];

/**
 * TXM-418 — identifica os relatórios da apuração ICMS (registro E110/E111 do
 * SPED Fiscal, CAT-42, Notas Fiscais — TXM-597 — e ECD — TXM-598). Mesmo motivo de `isRelatorioEsocial`:
 * são apurações por competência mensal e não têm os campos exclusivos de SPED/V3 (termos de
 * exclusão, critério de contas ECD).
 * @param {string | null | undefined} codigoRelatorio
 * @returns {boolean}
 */
export function isRelatorioIcms(codigoRelatorio) {
  return CODIGOS_RELATORIO_ICMS.includes(
    (codigoRelatorio ?? "").trim().toUpperCase()
  );
}

/**
 * TXM-418 — apuração ICMS "base" (a que cria a filha CAT-42 vinculada). Separada
 * de `isRelatorioIcms` porque só ela exibe os parâmetros de ICMS-ST/CAT-42 na
 * criação; a CAT-42 standalone não.
 * @param {string | null | undefined} codigoRelatorio
 * @returns {boolean}
 */
export function isRelatorioIcmsApuracao(codigoRelatorio) {
  return (codigoRelatorio ?? "").trim().toUpperCase() === "ICMS_APURACAO";
}

/**
 * Nome do relatório para exibição no select (corta sufixos após " - ").
 * @param {string | null | undefined} nome
 * @returns {string}
 */
export function nomeRelatorioParaExibicao(nome) {
  const s = String(nome ?? "").trim();
  if (!s) return "";
  const partes = s.split(/\s+[-–—]\s+/);
  return (partes[0] ?? s).trim();
}
